<template>
  <BaseDialog centered contentClass="delete-competitor" ref="dialog" persistent show-actions>
    <template slot="title">{{ $t('page.business-intelligence.competitor.delete-dialog.title') }}</template>
    <template slot="content">
      <span v-if="competitor">{{
        $t('page.business-intelligence.competitor.delete-dialog.description', { name: competitor.name })
      }}</span>
      <div class="delete-competitor__actions">
        <BaseButton is-outlined class="delete-competitor__cancel" @click.native="cancelClick">{{
          $t('actions.cancel')
        }}</BaseButton>
        <BaseButton @click.native="execute">
          <span>{{ $t('actions.delete') }}</span>
        </BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseDialog from '@/components/base/BaseDialog';
import { mapActions } from 'vuex';

export default {
  name: 'DeleteCompetitorDialog',
  components: {
    BaseButton,
    BaseDialog,
  },
  data() {
    return { competitor: null };
  },
  methods: {
    ...mapActions('biDashboard', ['deleteCompetitor']),

    open(competitor) {
      this.competitor = competitor;
      this.$refs.dialog.openModal();
    },
    close() {
      this.competitor = null;
      this.$refs.dialog.isModalOpen = false;
    },
    execute() {
      this.deleteCompetitor(this.competitor.id)
        .then(() => {
          this.$toast.success(this.$t('page.business-intelligence.competitor.delete-dialog.delete-success'));
        })
        .catch((error) => this.$toast.error(error));
      this.close();
    },
    cancelClick() {
      this.close();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__delete-competitor {
  min-height: 150px;
  max-height: 650px !important;
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }
  .close-icon__container {
    display: none;
  }
}

.delete-competitor {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }

  &__action {
    text-transform: lowercase;
    font-weight: bold;
  }
}
</style>
